import { _ as _objectSpread2 } from './index-c76be973.esm.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-7e1dfdab.esm.js';
import 'react';
import styled, { css, keyframes } from 'styled-components';
import { I as IconWrapper$1 } from './index.style-741fda20.esm.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react-helmet';
import '@reach/visually-hidden';
import 'react-element-to-jsx-string';
import { pxToRem, filterGlobalProps } from '@lendi-ui/commons/utils';
import { u as useTheme } from './index-ada59f60.esm.js';
import { getRadius, getFocusRing } from '@lendi-ui/commons/borders';
import getDepth from '@lendi-ui/commons/depth';
var getIconMargin = props => {
  var marginSize;
  switch (props.size) {
    case 'lg':
      marginSize = "".concat(pxToRem(20));
      break;
    case 'sm':
      marginSize = "".concat(pxToRem(8));
      break;
    case 'xs':
      marginSize = "".concat(pxToRem(6));
      break;
    default:
    case 'md':
      marginSize = "".concat(pxToRem(12));
  }
  return css(["", ""], props.position === 'start' ? "margin-right: ".concat(marginSize, ";") : props.position === 'end' ? "margin-left: ".concat(marginSize, ";") : '');
};
var IconWrapper = styled.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "lui__sc-1c5jz0y-0"
})(["display:inline-flex;", " ", ""], _ref => {
  var {
    position,
    size
  } = _ref;
  return getIconMargin({
    size,
    position
  });
}, props => props.isLoading && css(["visibility:hidden;"]));
var Icon = _ref2 => {
  var {
    isLoading,
    icon,
    position,
    size
  } = _ref2;
  var IconComponent = icon === null || icon === void 0 ? void 0 : icon.component;
  var isSmall = size === 'xs';
  return /*#__PURE__*/jsx(IconWrapper, {
    size: size,
    position: position,
    isLoading: isLoading,
    "aria-hidden": true,
    children: IconComponent && /*#__PURE__*/jsx(IconComponent, {
      height: isSmall ? '1.43em' : '1.5em',
      width: "auto"
    })
  });
};
var ButtonContent = _ref => {
  var {
    isLoading,
    icon,
    children,
    size
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [icon && icon.position !== 'end' && /*#__PURE__*/jsx(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    }), children && /*#__PURE__*/jsx("span", {
      style: isLoading ? {
        visibility: 'hidden'
      } : undefined,
      children: children
    }), icon && icon.position === 'end' && /*#__PURE__*/jsx(Icon, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      position: icon.position
    })]
  });
};

/**
 * This is a 100% duplicate of `@lendi-ui/icon/spinner`.
 *
 * It is used in LUI Next Button
 * It is duplicated so that, mono-package can be rid of LUI Now dependencies.
 *
 * @param props
 * @constructor
 */
function SpinnerIcon(props) {
  return /*#__PURE__*/jsx(IconWrapper$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      children: /*#__PURE__*/jsx("path", {
        d: "M10.088.584v3c2.96 0 5.062 1.734 6.006 4.014.944 2.28.682 4.99-1.41 7.082-2.093 2.092-4.803 2.354-7.082 1.41-2.28-.944-4.014-3.047-4.014-6.006h-3c0 4.168 2.576 7.415 5.865 8.777 3.289 1.362 7.406.889 10.354-2.058 2.947-2.947 3.42-7.065 2.058-10.354C17.503 3.16 14.256.584 10.088.584z"
      })
    })
  }));
}

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerIconWrapper = styled(SpinnerIcon).withConfig({
  displayName: "indexstyle__SpinnerIconWrapper",
  componentId: "lui__sc-ilwsxi-0"
})(["animation:", " 1.2s linear infinite;display:flex;line-height:0;width:100%;height:100%;svg{fill:currentColor;}"], spin);

/**
 * This is a 100% duplicate of `@lendi-ui/spinner`.
 *
 * It is duplicated so that, mono-package can be rid of LUI Now Color.
 *
 * @param variant
 * @constructor
 */
var Spinner = _ref => {
  var {
    variant = 'dark'
  } = _ref;
  var theme = useTheme();
  var color = variant === 'dark' ? theme.color.buttonForeground.default : 'white';
  return /*#__PURE__*/jsx(SpinnerIconWrapper, {
    color: color
  });
};
var BaseButtonStyles = css(["display:inline-block;text-align:center;position:relative;transition:background-color 0.2s ease-out,color 0.2s ease-out,box-shadow 0.2s ease-out;cursor:pointer;font-family:", ";font-weight:700;border:solid 2px transparent;:focus-visible{outline:solid 2px ", ";outline-offset:2px;}:disabled{cursor:default;pointer-events:none;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.asset.font.body.family;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
});
var getButtonSize = props => {
  var _props$minWidth;
  var minWidth;
  var padding;

  /**
   * @todo Tokens: font-size
   */
  var fontSizeValue = props.size === 'xs' ? 14 : 16;
  var lineHeightValue = props.size === 'xs' ? 1.43 : 1.5;
  switch (props.size) {
    case 'lg':
      padding = "".concat(pxToRem(18), " ").concat(pxToRem(40));
      minWidth = pxToRem(144);
      break;
    case 'sm':
      padding = "".concat(pxToRem(6), " ").concat(pxToRem(14));
      minWidth = pxToRem(90);
      break;
    case 'xs':
      padding = "".concat(pxToRem(4), " ").concat(pxToRem(10));
      minWidth = pxToRem(72);
      break;
    default:
    case 'md':
      padding = "".concat(pxToRem(10), " ").concat(pxToRem(22));
      minWidth = pxToRem(108);
  }
  return css(["", ";", ";min-width:", ";padding:", ";border-radius:", ";font-size:", ";line-height:", ";"], props.width ? "width: ".concat(props.width) : '', props.maxWidth ? "max-width: ".concat(props.maxWidth) : '', (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : minWidth, padding, getRadius('button'), pxToRem(fontSizeValue), lineHeightValue);
};
var getColorStyle = (variant, state) => {
  return css(["background-color:", ";color:", ";border-color:", ";"], _ref3 => {
    var {
      theme
    } = _ref3;
    return theme.color.buttonFill[variant][state];
  }, _ref4 => {
    var {
      theme
    } = _ref4;
    return theme.color.buttonForeground[variant][state];
  }, _ref5 => {
    var {
      theme
    } = _ref5;
    return theme.color.buttonBorder[variant][state];
  });
};

//
// OLD LENDI BUTTON STYLES
// This will be removed, this code is here to bridge the gap untill lendi theme is turned off
//
var getOldLendiStyles = (variantName, isInverse) => css(["text-transform:uppercase;letter-spacing:1.2px;border-width:1px;", ";&:disabled{opacity:0.4;}&:hover{box-shadow:", ";", ";}&:active{box-shadow:none;}:focus-visible{outline:0;box-shadow:", ",", ";}"], variantName.includes('text') ? "text-decoration: none; " : '', getDepth(4), variantName.includes('text') && !isInverse ? "box-shadow: ".concat(getDepth(3)) : '', getFocusRing(), getDepth(2, 'focusRing'));
var StyledButtonBase = styled.button.withConfig({
  displayName: "buttonstyles__StyledButtonBase",
  componentId: "lui__sc-1juyc07-0"
})(["", ";", ";", ""], BaseButtonStyles, props => getButtonSize(props), _ref6 => {
  var {
    isInverse,
    variant
  } = _ref6;
  var variantName = isInverse ? "".concat(variant, "Inverse") : variant;
  return css(["", ";", " &:disabled{", ";pointer-events:none;}&:hover{", ";", "}&:focus-visible{", ";", "}&:active{", ";transform:translateY(1px);", "}", ";"], getColorStyle(variantName, 'default'), variantName.includes('text') && "text-decoration: underline;", getColorStyle(variantName, 'disabled'), getColorStyle(variantName, 'hover'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'focus'), variantName.includes('text') && "text-decoration: none;", getColorStyle(variantName, 'pressed'), variantName.includes('text') && "text-decoration: none;", _ref7 => {
    var {
      theme
    } = _ref7;
    return theme.name === 'lendi' && getOldLendiStyles(variantName, isInverse);
  });
});
var _excluded$1 = ["variant", "width", "size", "ariaExpanded", "ariaLabel", "className", "isInverse", "minWidth", "maxWidth", "isLoading", "isDisabled", "icon", "children", "onPress", "onClick", "type"];
var Loader = styled.span.withConfig({
  displayName: "Button__Loader",
  componentId: "lui__sc-12k3xs9-0"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;width:", ";height:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === 'xs' ? '1.43em' : '1.5em';
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'xs' ? '1.43em' : '1.5em';
});
var StyledButton = styled(StyledButtonBase).withConfig({
  displayName: "Button__StyledButton",
  componentId: "lui__sc-12k3xs9-1"
})(["", ";"], _ref3 => {
  var {
    icon
  } = _ref3;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var Button = _ref4 => {
  var {
      variant = 'primary',
      width = 'auto',
      size = 'md',
      ariaExpanded,
      ariaLabel,
      className,
      isInverse,
      minWidth,
      maxWidth,
      isLoading,
      isDisabled,
      icon,
      children,
      onPress,
      onClick,
      type = 'button'
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded$1);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsxs(StyledButton, _objectSpread2(_objectSpread2({
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    className: className,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress,
    variant: variant,
    type: type,
    isLoading: isLoading,
    disabled: isDisabled,
    icon: icon
  }, globalProps), {}, {
    children: [isLoading && /*#__PURE__*/jsxs(Loader, {
      size: size,
      children: [/*#__PURE__*/jsx(Spinner, {
        variant: variant === 'primary' ? 'light' : 'dark'
      }), /*#__PURE__*/jsx("span", {
        className: "sr-only",
        children: "Loading"
      })]
    }), /*#__PURE__*/jsx(ButtonContent, {
      size: size,
      isLoading: isLoading,
      icon: icon,
      children: children
    })]
  }));
};
var _excluded = ["href", "target", "variant", "width", "isInverse", "ariaLabel", "minWidth", "maxWidth", "onPress", "onClick", "children", "className", "icon", "size"];
var StyledAnchorButton = styled(StyledButtonBase).withConfig({
  displayName: "AnchorButton__StyledAnchorButton",
  componentId: "lui__sc-6oc08b-0"
})(["", ";text-decoration:none;"], _ref => {
  var {
    icon
  } = _ref;
  return icon && "display: inline-flex; align-items: center; justify-content: center;";
});
var AnchorButton = _ref2 => {
  var {
      href,
      target,
      variant = 'primary',
      width,
      isInverse,
      ariaLabel,
      minWidth,
      maxWidth,
      onPress,
      onClick,
      children,
      className,
      icon,
      size = 'md'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledAnchorButton, _objectSpread2(_objectSpread2({
    as: "a",
    size: size,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    isInverse: isInverse,
    "aria-label": ariaLabel,
    className: className,
    variant: variant,
    href: href,
    target: target,
    icon: icon,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    onClick: onClick !== null && onClick !== void 0 ? onClick : onPress
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx(ButtonContent, {
      size: size,
      icon: icon,
      children: children
    })
  }));
};
export { AnchorButton as A, Button as B };